import React, {useState, useEffect, useMemo, useReducer, useCallback} from 'react'
import _ from 'lodash'

import {getEntityStatuses} from '../../state/entities/get-entities-statuses/actions'
import getEntitiesStatusesReducer from '../../state/entities/get-entities-statuses/reducer'

import {
  createReservationNextStepAction,
  resetReservationNextStepAction,
} from '../../state/reservation/create-reservation-next-step-action/actions'
import useReservationNextStepActionReducer from '../../state/reservation/create-reservation-next-step-action/reducer'

const StepActionContext = React.createContext()

const StepActionProvider = ({children}) => {
  const [nextStepAction, nextStepActionDispatch] = useReservationNextStepActionReducer()
  const [files, setFiles] = React.useState([])
  // will use snake case for easier json
  const [stepActionData, setStepActionData] = useState({
    entity_id: null,
    action_fields: [],
    entity_action_id: null,
    object_ids: [],
    reservation_uid: '',
    return: false,
  })

  // get-all-entities
  const [statuses, getStatusesDispatch] = useReducer(getEntitiesStatusesReducer, {
    error: null,
    isLoading: true,
    data: [],
  })
  const getStatuses = useCallback((id, params = {}) => {
    getEntityStatuses(id, params, getStatusesDispatch)
  }, [])

  const update = (k, v) => {
    setStepActionData(r => ({...r, [k]: v}))
  }

  const updateValue = (k, v) => {
    let _stepActionData = stepActionData.action_fields.map(af => {
      if (af.key === k) {
        af.value = v
      }
      return af
    })
    update('action_fields', _stepActionData)
  }

  const clearStepActionData = useCallback(() => {
    setStepActionData({
      entity_id: null,
      action_fields: [],
      entity_action_id: null,
      object_ids: [],
    })
  }, [setStepActionData])

  const clearReservationsNextStepAction = () => {
    resetReservationNextStepAction(nextStepActionDispatch)
  }

  // get configuration data
  const addReservationNextStepAction = useMemo(() => {
    const body = JSON.stringify({files})
    return reservationData => {
      let _actionFields = stepActionData.action_fields.map(af => {
        return {
          key: af.key,
          type: af.type,
          value: af.value,
        }
      })
      return createReservationNextStepAction(nextStepActionDispatch, {
        ...stepActionData,
        body,
        action_fields: _actionFields,
      })
    }
  }, [nextStepActionDispatch, stepActionData, files])

  const value = {
    stepActionData,
    setStepActionData,
    nextStepAction,
    update,
    statuses,
    files,
    getStatuses,
    setFiles,
    updateValue,
    clearStepActionData,
    addReservationNextStepAction,
    clearReservationsNextStepAction,
  }

  return <StepActionContext.Provider value={value}>{children}</StepActionContext.Provider>
}

const StepActionConsumer = StepActionContext.Consumer

export {StepActionProvider, StepActionContext, StepActionConsumer}
